<template>
  <rest-page :fetch-endpoint="fetchEndpoint" class="page-ct">
    <page-header-new :title="gameName" :breadcrumbs="breadcrumbs" />
    <div class="wrapper">
      <game-frame :project-id="projectId" :domain="domain" :token="token" />
    </div>
  </rest-page>
</template>

<script>
import GameFrame from '@/modules/gamification/components/games-hub-dashboard/GameFrame.vue'
import PageHeaderNew from '@/common/components/page/PageHeaderNew.vue'
import RestPage from '@/common/components/rest/RestPage.vue'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'GameDashboardPage',
  components: { RestPage, PageHeaderNew, GameFrame },

  data() {
    return {
      token: null,
      gameName: ''
    }
  },

  computed: {
    projectId() {
      return this.$route.query.project_id
    },

    domain() {
      return this.$route.query.domain
    },

    gameId() {
      return this.$route.query.id
    },

    fetchEndpoint() {
      return [this.fetchTokenEndpoint, this.fetchGameEndpoint]
    },

    fetchTokenEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `gamification/auth/token`,
        params: {
          domain: this.domain,
          game_id: this.gameId
        },
        handler: data => {
          this.token = data.token
        }
      })
    },

    fetchGameEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `games/${this.gameId}`,
        handler: data => {
          this.gameName = data.name
        }
      })
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('LeftNavigation_Games_Hub'),
          route: projectRoute({
            name: 'GamesHub'
          })
        },
        {
          label: this.gameName
        }
      ]
    }
  }
}
</script>

<style scoped>
.page-ct {
  position: relative;
}
.wrapper {
  position: absolute;
  top: 97px;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GameDashboardPage.vue